<template>
	<div class="p-3">
		<div class="p-3 shadow border-15 overflow-hidden bg-white">
			<div class="w-100 text-center">
				<userImg
					imgClass="m-auto"
					:src="user.username.img"
				/>
			</div>
			<p class="p-3 text-center bMikhak m-0">
				{{user.username.fullname}}
			</p>
			<hr class="mt-0 mb-3" />

			<!-- <router-link to="/dashboard_user">
				<btn
					:type="(location_pathname=='/dashboard_user') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="داشبورد"
				/>
			</router-link> -->
			<!-- <span v-if="this.$localStorage.get('user').username.role==2">
				<router-link to="/signupTeacher" v-if="this.$localStorage.get('user').username.status!=2">
					<btn
						:type="(select=='6') ? 'orange' : 'white'"
						class="w-100"
						shadow="0"
						textClass="w-100 border-hover"
						text="پروفایل"
					/>
				</router-link>
			</span> -->
			<!-- <router-link to="/reserved/user/list">
				<btn
					:number="menu_count.reserved"
					:type="(select=='0') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="درخواست های من"
				/>
			</router-link> -->
			<!-- <a href="/teachers" v-if="this.$localStorage.get('user').username.role==1">
				<btn
					:type="(select=='15') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="مشاهده و انتخاب"
				/>
			</a> -->
			<!-- <router-link to="/proposal" v-if="this.$localStorage.get('user').username.role==1">
				<btn
					:type="(select=='5') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="درخواست مدرس از ایزی تیک"
				/>
			</router-link>
			<router-link to="/class/list">
				<btn
					:type="(select=='1_2') ? 'orange' : 'white'"
					shadow="0"
					class="w-100"
					textClass="w-100 border-hover"
					text="مدیریت کلاس ها"
					v-if="user.username.role=='2'"
				/>
			</router-link>
			<router-link to="/self" v-if="this.$localStorage.get('user').username.role==1">
				<btn
					:type="(select=='1') ? 'orange' : 'white'"
					shadow="0"
					class="w-100"
					textClass="w-100 border-hover"
					text="ویرایش اطلاعات"
				/>
			</router-link>

			<router-link to="/self/setpass">
				<btn
					:type="(select=='2') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="ویرایش کلمه عبور"
				/>
			</router-link>
			<router-link to="/pay/list">
				<btn
					:type="(select=='3') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="تراکنش های مالی"
				/>
			</router-link> -->
			<router-link to="/ticket/list">
				<btn
					:type="(select=='17') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="تیکت‌ها"
				/>
			</router-link>
			<!-- <router-link to="/ai">
				<btn
					:type="(select=='18') ? 'orange' : 'white'"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover"
					text="ابزارک‌های هوشمند"
				/>
			</router-link> -->
			<btn
				id_btn="exit_btn_id_web"
				class="w-100"
				shadow="0"
				textClass="w-100 border-hover text-danger"
				type="white"
				text="خروج"
				@clickMe="exit(1)"
			/>
			<btn
				id_btn="exit_btn_id_mobile"
				v-show="false"
				class="w-100"
				shadow="0"
				textClass="w-100 border-hover text-danger"
				type="white"
				text="خروج"
				@clickMe="exit(2)"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../UI/button/btn.vue";
		import userImg from  "../UI/userImg/userImg.vue";
  	import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
		export default {
			name: 'headMenu',
			data(){
				return {
					mgt: false,
					userL: false,
					user: [],
					menu_count: {
						'reserved': 0,
					},
					location_pathname: window.location.pathname
				}
			},
			props: {
				select:{
					default: "0"
				},
			},
			components: {
				btn,
				userImg
			},
			mounted(){
				this.user = this.$localStorage.get("user");
				if (this.user.username.role==2) {
					// this.teachers_count();
				}
			},
			methods:{
				teachers_count(THIS = this){
					window.$.post(window.baseurl+"teachers/menu_cnt", {
						token: this.$localStorage.get("user")
					}, function(D){
						if(D.ok) THIS.menu_count = D.data
					}, "json");
				},
				//***********************************************************
				exit(mod="1"){
					this.$swal.fire({
						position: 'center',
						type: '',
						title: "خروج از حساب",
						html: "<div class='text-center w-75 m-auto'><hr/> آیا مطمئن هستید می خواهید از حساب کاربری خود خارج شوید.</div>",
						showCloseButton: true,
						showConfirmButton: true,
						confirmButtonText: "خیر",
						confirmButtonClass:"btn btn-outline-success border w-50",
						showCancelButton: true,
						cancelButtonText: "بلی خروج!",
						cancelButtonClass:"btn btn-danger w-50",
					}).then((result) => {
						if (result.dismiss=="cancel") {
							this.$localStorage.remove('user');
							var rtr = (mod=="1") ? "/" : "/login";
							this.$router.push(rtr);
						}
					})
				}
			}
		}
	</script>
<style>
	@import "../css/templatemo-main.css";
	.swal2-actions {
    flex-wrap: nowrap !important;
	}
</style>
